module.exports = __webpack_public_path__ + "static/RMTAINA-a6fc83feea6d070ce1e7390ac6ca16f6.ttf";